import request from '@/utils/http';
// 查询
export const queryCustomerList = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierDrainageCustomerInfoList`,
        method: 'post',
        data: params
    });
};
// 天眼查询
export const fillData = (params) => {
    return request({
        url: `/api-srm-web/supplier/supplierDrainageCustomerInfo/fillData`,
        method: 'post',
        data: params
    });
};

// 新增
export const addCustomer = (params) => {
    return request({
        url: `/api-srm-web/supplier/createCooperationCustomer`,
        method: 'post',
        data: params
    });
};

// 删除
export const deleteCustomer = (params) => {
    return request({
        url: `/api-srm-web/supplier/deleteDrainageCustomerInfo/${params}`,
        method: 'get',
        data: params
    });
};